import { render } from "./AverageEnrollmentRate.vue?vue&type=template&id=534cc95f&ts=true"
import script from "./AverageEnrollmentRate.vue?vue&type=script&lang=ts"
export * from "./AverageEnrollmentRate.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__